import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'transfer', 'Transfer', [["path",{"d":"M20 10h-16l5.5 -6"}],["path",{"d":"M4 14h16l-5.5 6"}]]);